import PropTypes from 'prop-types';
import React, { useEffect, useCallback } from 'react';

import Rules, { rulesCondition, rulesGroup, rulesRoot } from 'components/rules/Rules';
import { PATH_IMPRESSION_EXTRA_RULES, PATH_PING_POST_RULES, TCPA_CONSENT_DBA_RULE, TRANSACTION_VALUE_RULE } from './utils';

const propTypes = {
  data: PropTypes.object,
  vendor: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onConflict: PropTypes.func,
};

export default function IntegrationRules({ data, onChange, vendor, type, onConflict }) {
  useEffect(() => {
    const { groups: [{ rules: conditions = [] } = {}] = [] } = data || {}

    if (type === 'revenue_share' && vendor === 'google_ads') {
      const added = conditions.find(c => c.key === 'pid')
      if (!added) {
        conditions.push(rulesCondition('pid', 'publisher'))
        onChange(data || rulesRoot([rulesGroup(conditions)]))
      }
    }
    if (type === 'path_impression' && conditions.length === 0) {
      conditions.push(rulesCondition('', ''))
      onChange(data || rulesRoot([rulesGroup(conditions)]))
    }
  }, [vendor, type])

  const getDisabled = useCallback((rule, idx) => {
    if (vendor === 'google_ads') {
      if (rule.key === 'pid' && idx === 0) return true
    }

    return false
  }, [vendor])

  return <Rules
    origin='integration'
    rules={data}
    getDisabled={getDisabled}
    handleChange={({ rules }) => onChange(rules)}
    integrationType={type}
    extraFields={EXTRA_FIELDS[type] || []}
    onConflict={onConflict}
  />
}

const EXTRA_FIELDS = {
  path_impression: [...PATH_IMPRESSION_EXTRA_RULES, TCPA_CONSENT_DBA_RULE],
  path_ping_post: PATH_PING_POST_RULES,
  delayed_register: [TCPA_CONSENT_DBA_RULE],
  register: [TCPA_CONSENT_DBA_RULE],
  revenue_share: [TCPA_CONSENT_DBA_RULE, TRANSACTION_VALUE_RULE],
}

IntegrationRules.propTypes = propTypes
IntegrationRules.defaultProps = {}
